<div class="dialoghead">
    <h1 class="mat-mdc-dialog-title">Alert!!</h1>
    <mat-dialog-content>
      <p>
        Are you sure you want to unsubscribe from the <strong>Perennial Mandalism Dashboard</strong>? If you unsubscribe, you will lose access to its guided practices for mandala creation and contemplation, insights into their timeless wisdom, and more.
      </p>
      <p>
        Your current access will continue until your subscription expires on <strong>{{ prevData?.expiry_date | date:'EEEE, MMMM d, y' }}</strong>. After this date, you will lose all access associated with this subscription.
      </p>
      <p>This action can usually be reversed by resubscribing later.</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="unsubscribe()">Unsubscribe</button>
      <button mat-button (click)="closeModal()">Cancel</button>
    </mat-dialog-actions>
    <ng-container *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>
  </div>
  
  <span mat-button mat-dialog-close class="close-btn-modal material-icons"
    >close</span
  >
  